import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import Layout from '../components/layout/Layout';

interface PrivateRouteProps extends RouteProps {
    component: React.ComponentType<any>;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            localStorage.getItem('token') ? (
                <Layout>
                    <Component {...props} />
                </Layout>
            ) : (
                <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            )
        }
    />
);

export default PrivateRoute;
